/**
 * Отключает счётчик Метрики для e2e-прогонов.
 *
 * Playwright-тесты гоняются в том числе по проду и доходят до оформления
 * заказа. Фильтра в `reachGoal`/`ecommerce` мало: часть целей вызывает `ym()`
 * напрямую (`hit` при смене страницы, `showMore`, `page404` и т.д.), да и
 * вебвизор писал бы записи ботов.
 *
 * Скрипт заглушает `window.ym` ДО инлайн-кода счётчика: тот делает
 * `m[i] = m[i] || function(){...}`, видит нашу функцию и не заводит очередь
 * `ym.a`, поэтому `tag.js` не выполнит `init` — визит не засчитывается.
 * Поэтому компонент должен стоять выше блока `scripts` в разметке.
 *
 * Признаки автоматизации те же, что в `utils/tracking/isAutomated`.
 */
const GUARD = `(function(){try{
var w=window;
var isE2E=navigator.webdriver===true||w.__E2E__===true||/[?&]e2e=1/.test(location.search)||document.cookie.indexOf("e2e=1")>-1||sessionStorage.getItem("isE2E")==="1";
if(!isE2E){return}
try{sessionStorage.setItem("isE2E","1")}catch(e){}
w.ym=function(){};
}catch(e){}})();`;

export default function E2EGuard() {
  // eslint-disable-next-line react/no-danger
  return <script dangerouslySetInnerHTML={{ __html: GUARD }} />;
}
